import styled from 'styled-components/macro'

const Svg = styled.svg`
  display: block;
  position: absolute;
  transform: translateY(20%);
  margin-left: -0.9em;
`

export const ActiveLinkIcon = () => (
  <Svg
    width="0.6em"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9513 10.9043C12.6213 10.4059 5.06071 6.15987 0.128893 0.0569172C0.0468239 -0.0696358 -0.0249862 0.049169 0.00835419 0.085327L4.12205 10.9534L0.0109188 21.8886C0.0109188 21.8886 -0.0070337 22.0978 0.177621 21.9428C5.10944 15.8838 12.6546 11.5113 20.9513 11.005C20.9513 11.005 21 10.9947 21 10.956C21 10.9172 20.9513 10.9069 20.9513 10.9069V10.9043Z"
      fill="currentColor"
    />
  </Svg>
)
